import styled from "styled-components";
import { Dialog, Button, IconButton } from "@material-ui/core";

export const DialogContainer = styled(Dialog)`
  && {
    .MuiPaper-root {
      max-width: 1000px;
      @media screen and (max-width: 737px) {
        max-width: initial;
      }
    }
  }
`;

export const FlexWrapper = styled.div`
  display: flex;
  width: 1000px;
  > div {
    width: 50%;
  }
  @media screen and (max-width: 737px) {
    display: block;
    width: initial;
    > div {
      width: auto;
    }
  }
`;

export const LoginWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing * 20}px
    ${({ theme }) => theme.spacing * 6}px;
  text-align: center;
  h3 {
    font-size: 24px;
    margin: 0;
  }
  @media screen and (max-width: 737px) {
    padding: 0 ${({ theme }) => theme.spacing * 2}px;
    height: 100%;
  }
`;

export const SocialLoginWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 24px 0 0;
`;

export const SocialLogin = styled(IconButton)`
  background-color: ${(props) => props.iconHex} !important;
  && {
    padding: 4px 40px;
    color: #fff;
    border-radius: 6px;
    width: 30%;
    font-size: 20px;
    font-weight: bold;
    height: 40px;
  }
`;

export const RulesMessage = styled.p`
  color: ${({ theme }) => theme.colors.mediumGray};
  font-size: 12px;
  margin: 120px 0 8px 0;
  @media screen and (max-width: 767px) {
    margin-top: ${({ theme }) => theme.spacing * 12}px;
  }
`;

export const StyledButton = styled(Button)`
  && {
    width: 100%;
    border-radius: 6px;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.primary};
    font-weight: bold;
    padding: 0 ${({ theme }) => theme.spacing * 8}px;
    height: 44px;
    &:hover {
      color: ${({ theme }) => theme.colors.primary};
      background-color: ${({ theme }) => theme.colors.white};
    }
    @media screen and (max-width: 767px) {
      margin: ${({ theme }) => theme.spacing * 12}px 0
        ${({ theme }) => theme.spacing * 4}px;
    }
  }
`;

export const DividerWrapper = styled.div`
  position: relative;
  margin: 32px 0 24px;
  span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    padding: 4px;
  }
`;

export const StyledLink = styled.p`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
  text-decoration: none;
  font-weight: bold;
  text-transform: capitalize;
  line-height: 40px;
  display: inline;
  cursor: pointer;
`;

export const DontHaveAccount = styled.p`
  margin: 0;
  font-size: 14px;
  span {
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: bold;
    font-size: 16px;
    margin-left: ${({ theme }) => theme.spacing}px;
  }
`;
